import React, { Component } from 'react'
import DataGrid from "../../components/DataGrid";
import Pagination from "../../components/Pagination";
import FinancialBox from "../../components/boxes/FinancialBox";
import ProductViewBox from './ProductViewBox';
import SidebarView from '../../components/SidebarView';
import { checkTranslation, conditionalWidth, imageAddress, translate } from '../../utils/useful';
import Collapsible from 'react-collapsible';
import Responsive from '../../components/Responsive';
import Monitor from "../../windows/DeskViews/Monitor";
import AddressPage from './AddressPage';
import ShopProfile from './CommerceCart';
import StagesManager from '../../components/StagesManager';



export default class ShopAccount extends Component {
    state = {
        showCollapse: null,
        active: false,
        // selected: 0,

        // show: false,

        // product: [
        //     { name: 'Nouveau', title: 'AirPods Pro (2ᵉ génération)', price: '299,00', src: '/images/product/photo1.jfif' },
        //     { name: 'Nouveau', title: 'Coque en cuir avec MagSafe pour iPhone 14 Pro Max - Vert forêt', price: '299,00', src: '/images/product/photo2.jfif' },
        //     { name: 'Nouveau', title: 'Apple TV 4K Wi‑Fi + Ethernet avec 128 Go de stockage', price: '299,00', src: '/images/product/photo3.jfif' },
        //     { name: 'Nouveau', title: 'HomePod mini - Gris sidéral', price: '299,00', src: '/images/product/photo4.jfif' },
        //     { name: 'Nouveau', title: 'Lanière AirTag - Rose agrume', price: '299,00', src: '/images/product/photo5.jfif' },
        // ],
        // filter: [
        //     { name: 'Categories' },
        //     { name: 'Brand' },
        //     { name: 'Price' },
        // ],
        // option: [
        //     { name: "Discounts and offers", src: '/assets/icons/target.svg' },
        //     { name: "best sellers", src: '/assets/icons/flame.svg' },
        //     { name: "amazing", src: '/assets/icons/chart.svg' },
        // ],
        type: [
            { name: "{{lang}}No items saved for later", des: "{{lang}}" },
            { name: "{{lang}}Buy it again", des: "{{lang}}No items to Buy again" },
        ],

        accountList: [
            { key: "orders", icon: "/images/icons/ad-center.png", title: "{{lang}}Your Orders", des: "{{lang}}Track, return or buy things again" },
            { key: "voucher", icon: "/images/icons/ads-manager.png", title: "{{lang}}Voucher", des: "{{lang}}View balance, redeem or reload cards" },
            { key: "payments", icon: "/images/icons/comunities.png", title: "{{lang}}Your Payments", des: "{{lang}}View all transactions, manage payment methods and settings" },
            { key: "address", icon: "/images/icons/crisis.png", title: "{{lang}}Your Addresses", des: "{{lang}}View and modify your addresses" },
            { key: "wish", icon: "/images/icons/events.png", title: "{{lang}}Wish lists", des: "{{lang}}View, modify and share your lists or create new ones" },
        ]

    }

    // showNotifications = () => {

    // }

    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    componentDidMount() {
        this.setState({ currentIndex: 0, currentItem: this.state.type[0] })
    }
    render() {
        let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub
        let variables = {
            appletId: this.props.applet?._id,
            appletHub: appletHub
        }
        let type = this.state.type
        return (
            <div>
                <div className='h-100 scroll-no-scrollbar w-100 window-content-radius'>
                    {/* <div className='w-100 d-flex px-3 py-3' style={{ background: "linear-gradient(to right, rgba(70, 133, 204, .9), rgba(70, 70, 204, .9))", }}>
                        <div className='flexcc'>
                            <button className='flexcc br-10 mrd-3 icon-box' style={{ width: "30px", height: "30px" }} onClick={() => this.props.changeStage("")} >
                                <img width={20} src='/assets/icons/arrow-left-white.svg' />
                            </button>
                        </div>
                        <div className='flexc'>
                            <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="40px" className='prd-3' style={{ objectFit: 'cover', borderRadius: 100 }} />
                            <div className=''>
                                <p className='font-size-20 white'>{translate('Account & List')}</p>
                                <p className='white font-size-14' style={{ marginTop: "-5px" }}>{translate(`Hossein Mohseni`)}</p>
                            </div>
                        </div>
                    </div> */}


                    <div className='mx-3 mt-3 '>
                        <div className='d-flex flex-wrap'>
                            {this.state.accountList.map((prop, index) => {
                                return (

                                    <Responsive className='my-2' width={this.props.width} media={this.props.col ?? { xs: "12", sm: '4', md: '4', lg: "3", xl: "3" }}>
                                        <div className='d-flex mx-2 account-box p-2 br-10 h-100' style={{ cursor: 'pointer', }} onClick={() => this.props.changeStage(prop.key)}>
                                            <img className='mrd-3' style={{ width: "30px", height: "30px" }} src={prop.icon} />
                                            <div>
                                                <p className='font-size-14 wieght-500 title-color'>{checkTranslation(prop.title)}</p>
                                                <p className='font-size-10 des-color'>{checkTranslation(prop.des)}</p>
                                            </div>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
